import React from "react";
import ChatCard from "./ChatCard/ChatCard.component";

const Chats = ({ chats }) =>
  chats.map(chat => <ChatCard chat={chat} key={chat.id} />);

export default Chats;
